import React, { useMemo } from 'react';
import * as ReactDOMClient from 'react-dom/client';
import MissionInformation from '../MissionInformation/MissionInformation';
import { useGetWithAxios } from '../../Hooks/useGetWithAxios';
import '../../style.css';
import { NotFound } from '../../Components/NotFound';
import { PageSkeleton } from '../../Components/PageSkeleton';
import { UserDistance } from './UserDistance';
const ShareDistance = () => {
    const distanceUrlExtension = useMemo(() => {
        const [extension] = window.location.pathname.split('/').slice(-1);
        return extension;
    }, []);
    const { data: distanceData, status: distanceStatus } = useGetWithAxios('/appv2/share-page/distance-data', {
        params: { distance_url_extension: distanceUrlExtension },
    });
    const flagForMissionInformation = (() => {
        if (!distanceData || distanceData?.distanceExists === 1) {
            return '';
        }
        return distanceData.conqFlagImage;
    })();
    return (React.createElement("div", { className: 'screen' },
        !!(distanceData?.distanceExists === 1) ? (React.createElement(UserDistance, { data: distanceData })) : (distanceStatus === 'fetching' && React.createElement(PageSkeleton, null)),
        React.createElement(MissionInformation, { missionId: distanceData?.missionId, lang: distanceData?.lang, conqFlagImage: flagForMissionInformation }),
        distanceStatus === 'error' && !distanceData && React.createElement(NotFound, null)));
};
const rctShareDistance = document.getElementById('rct-share-distance');
if (rctShareDistance !== null) {
    ReactDOMClient.createRoot(rctShareDistance).render(React.createElement(ShareDistance, null));
}
